import AgendaServicosApiService from "@/common/agendaservicos.api.service";
import store from '@/plugins/store';

const agendamentoOnlineAuthenticationMiddleware = async (to, from, next) => {
  var alias = to.fullPath.split("/")[1];

  if (store.getters.autenticacaoMicrovixAgendamentoOnline.autenticado && store.getters.autenticacaoMicrovixAgendamentoOnline.alias == alias)
    return next();

	if (alias) {
		var regexp1 = new RegExp("^[0-9A-Za-z_.-]+$");
		if (!regexp1.test(alias)) return next(false);

    const payload = {
      Alias: alias,
    };

    try {
      await AgendaServicosApiService.autenticacaoPorAlias(payload)
      if (!store.getters.autenticacaoMicrovixAgendamentoOnline.autenticado) return next({ name: "NotFound" });
      if (to.name != "HomeAgendamentoOnline") return next();
      return next({ name: `${alias}Home` });
    } catch (e) {
      return next({ name: "NotFound" });
    }
	}
};

export {
	agendamentoOnlineAuthenticationMiddleware,
};
